export default __webpack_public_path__ + "static/media/header_accueil.c97ca3cd.jpg";